import * as checked from 'reporting-data/lib/checked';
import { Dataset } from 'reporting-data/v2/dataset/datasetRecords';
import { TABLE } from '../../constants/visualizationTypes';
export const Alignments = {
  left: 'left',
  right: 'right'
};
export const Align = checked.symbol(Alignments, 'Align');
export const Directions = {
  ascending: 'ascending',
  descending: 'descending'
};
export const Direction = checked.symbol(Directions, 'Direction');
export const Footer = checked.record({
  dataset: checked.any(),
  field: checked.string(),
  value: checked.any(),
  label: checked.string().optional()
}, 'Footer');
export const Column = checked.record({
  index: checked.number().optional(),
  dataset: checked.any(),
  field: checked.string(),
  label: checked.string().optional(),
  linkField: checked.string().optional(),
  align: Align.optional(),
  direction: Direction.optional(),
  footer: Footer.optional(),
  onClick: checked.func().optional(),
  getOnPointClick: checked.func().optional(),
  onSort: checked.func().optional(),
  tooltipI18nKey: checked.string().optional(),
  tooltipText: checked.string().optional(),
  customRendererKey: checked.string().optional(),
  renderCell: checked.func().optional(),
  renderHeaderCell: checked.func().optional(),
  renderFooterCell: checked.func().optional(),
  showAsBarChart: checked.boolean().optional(),
  showAsBarChartOptions: checked.map().optional(),
  useRawDataLabel: checked.boolean().defaultValue(false),
  formattingType: checked.string().optional(),
  //One of AutoFormatting, NumberFormatting, PercentFormatting, or CurrencyFormatting
  //{ type: string, customPrecision?: number, negativeSymbol?: string currencyCode?: string }
  formattingObject: checked.any().optional(),
  conditionalFormatter: checked.func().optional(),
  style: checked.any().optional()
}, 'Column');
export const Style = checked.record({
  isMobile: checked.boolean().optional()
}, 'Style');
export const Events = checked.record({
  getOnPointClick: checked.func().optional()
}, 'Events');
const ColumnsList = checked.listOrIterableToList(Column).optional();
const ToggleSeriesParams = checked.record({
  toggleSeriesHandler: checked.func().optional(),
  toggleAllSeriesHandler: checked.func().optional(),
  seriesToggleDisabled: checked.any().optional(),
  checkedSeries: checked.list().optional(),
  colors: checked.map().optional(),
  dimension: checked.string().optional()
}, 'toggleSeriesParams');
export const TableVisualization = checked.record({
  type: checked.string().always(TABLE),
  data: checked.map(Dataset),
  columns: ColumnsList,
  footer: checked.string().optional(),
  pages: checked.number().optional(),
  style: Style.optional(),
  events: Events.optional(),
  showTotals: checked.boolean().optional(),
  toggleSeriesParams: ToggleSeriesParams.optional(),
  onTableCellLinkClick: checked.func().optional()
}, 'TableVisualization');